const { IS_ENTERPRISE } = require("config");

export const getLabelIndustrialArea = () => IS_ENTERPRISE ? 'Phân khu' : 'KCN/CCN'


// WEBPACK FOOTER //
// ./src/utils/misc.js